<form [formGroup]="metadataFormGroup">
  <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
    Assurance Machines
  </div>

  <ng-container formGroupName="machinesInsuranceMetadata">
    <div class="row row-cols-1 my-3">
      <div class="col">
        <label i18n>Machines</label>
        <div class="form-check">
          <input
            type="radio"
            name="machinesInsured"
            id="machinesInsuredFalse"
            [value]="false"
            formControlName="machinesInsured"
          />
          <label class="form-check-label" for="machinesInsuredFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="machinesInsured"
            id="machinesInsuredTrue"
            [value]="true"
            formControlName="machinesInsured"
          />
          <label class="form-check-label" for="machinesInsuredTrue">Oui</label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="machinesInsuredValue">
      <div class="row row-cols-1 my-3">
        <div class="col">
          <label i18n>Couverture complémentaire</label>
          <div class="form-check">
            <input
              type="radio"
              name="complementaryCoverage"
              id="complementaryCoverageFalse"
              [value]="false"
              formControlName="complementaryCoverage"
            />
            <label class="form-check-label" for="complementaryCoverageFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="complementaryCoverage"
              id="complementaryCoverageTrue"
              [value]="true"
              formControlName="complementaryCoverage"
            />
            <label class="form-check-label" for="complementaryCoverageTrue"
              >Oui</label
            >
          </div>
        </div>
      </div>

      <ng-container formGroupName="firstTypeMachineCoverage">
        <div class="row my-3">
          <div class="col">
            <label i18n>Inventaire des machines 1</label>
            <textarea
              class="form-control"
              formControlName="inventory"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="row row-cols-1 my-3">
          <div class="col">
            <label i18n>Couvertures</label>
            <mat-form-field class="lty-input">
              <mat-select formControlName="cover">
                <mat-option [value]="null" i18n>Sélectionner</mat-option>
                <mat-option
                  *ngFor="let cover of machineCoverValues"
                  [value]="cover"
                >
                  {{ getBusinessMachineCoverLabel(cover) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <label i18n>Somme d'assurance</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
      </ng-container>

      <ng-container formGroupName="secondTypeMachineCoverage">
        <div class="row my-3">
          <div class="col">
            <label i18n>Groupe de machines 2</label>
            <textarea
              class="form-control"
              formControlName="inventory"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="row row-cols-1 my-3">
          <div class="col">
            <label i18n>Couverture</label>
            <mat-form-field class="lty-input">
              <mat-select formControlName="cover">
                <mat-option [value]="null" i18n>Sélectionner</mat-option>
                <mat-option
                  *ngFor="let cover of machineCoverValues"
                  [value]="cover"
                >
                  {{ getBusinessMachineCoverLabel(cover) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <label i18n>Somme d'assurance</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
      </ng-container>

      <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
        Perte d'exploitation
      </div>
      <ng-container formGroupName="lossCoverage">
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <div class="form-check">
              <input
                type="radio"
                id="machineLossCoveredFalse"
                [value]="false"
                formControlName="covered"
              />
              <label class="form-check-label" for="machineLossCoveredFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="machineLossCoveredTrue"
                [value]="true"
                formControlName="covered"
              />
              <label class="form-check-label" for="machineLossCoveredTrue"
                >Oui</label
              >
            </div>
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="machineLossCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Groupe de machines</label>
            <mat-form-field class="lty-input">
              <mat-select formControlName="machinesGroup">
                <mat-option [value]="null" i18n>Sélectionner</mat-option>
                <mat-option
                  *ngFor="let group of machineGroupValues"
                  [value]="group"
                >
                  {{ getBusinessMachineGroupLabel(group) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <label i18n>Délai de carence</label>
            <mat-form-field class="lty-input">
              <mat-select formControlName="waitingDelay">
                <mat-option [value]="null" i18n>Sélectionner</mat-option>
                <mat-option
                  *ngFor="let delay of waitingDaysValues"
                  [value]="delay"
                >
                  {{ getBusinessWaitingDaysLabel(delay) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row my-3" *ngIf="machineLossCoverageCoveredValue">
          <div class="col">
            <label i18n>Machines nominatives</label>
            <textarea
              class="form-control"
              formControlName="namedMachines"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="row my-3" *ngIf="machineLossCoverageCoveredValue">
          <div class="col">
            <label i18n>Couverture en</label>
            <input
              type="text"
              class="form-control"
              formControlName="coverageIn"
            />
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="machineLossCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Somme d'assurance</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
      </ng-container>

      <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
        Frais supplémentaires
      </div>
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('additionalFeesCoverage')"
        name="additionalFees"
      />

      <label i18n>Outils et moules interchangeables</label>
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('toolsMoldsCoverage')"
        name="toolsMolds"
      />

      <label i18n
        >Supports de données et frais de reconstitution d'informations</label
      >
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('dataCarriersCoverage')"
        name="dataCarriersMachines"
      />

      <label i18n>Pièces de mobilier</label>
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('furniturePiecesCoverage')"
        name="furniturePieces"
      />

      <label i18n
        >Prestations supplémentaires de construction, frais de
        déblaiement</label
      >
      <app-basic-coverage-form
        [formGroup]="
          getMachinesBasicCoverageGroup(
            'additionalConstructionServicesCoverage'
          )
        "
        name="additionalConstructionServicesMachines"
      />

      <label i18n
        >Frais de sauvetage des passagers d'installation de transport</label
      >
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('rescueCostsCoverage')"
        name="rescueCosts"
      />

      <label i18n>Dommages dus aux troubles intérieurs</label>
      <app-basic-coverage-form
        [formGroup]="
          getMachinesBasicCoverageGroup('internalDisturbancesDamageCoverage')
        "
        name="internalDisturbancesMachines"
      />

      <div class="row row-cols-md-2 row-cols-sm-1 my-3">
        <div class="col">
          <label i18n>Inaccessibilité en cas d'utilisation souterraine</label>
          <div class="form-check">
            <input
              type="radio"
              id="undergroundInaccessibilityMachinesFalse"
              [value]="false"
              formControlName="undergroundInaccessibilityCoverage"
            />
            <label
              class="form-check-label"
              for="undergroundInaccessibilityMachinesFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              id="undergroundInaccessibilityMachinesTrue"
              [value]="true"
              formControlName="undergroundInaccessibilityCoverage"
            />
            <label
              class="form-check-label"
              for="undergroundInaccessibilityMachinesTrue"
              >Oui</label
            >
          </div>
        </div>
      </div>

      <label i18n
        >Dommages dus à l'incendie, aux événements naturels sur les ITG</label
      >
      <app-basic-coverage-form
        [formGroup]="
          getMachinesBasicCoverageGroup('fireNaturalDisasterCoverage')
        "
        name="fireNaturalDisasterMachines"
      />

      <label i18n>Dommages dus au vol pour les ITG</label>
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('theftCoverage')"
        name="theftMachines"
      />

      <label i18n>Indemnisation à la valeur à neuf</label>
      <app-basic-coverage-form
        [formGroup]="getMachinesBasicCoverageGroup('replacementCostCoverage')"
        name="replacementCostMachines"
      />
    </ng-container>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
    Assurance Installations Techniques
  </div>

  <ng-container formGroupName="technicalInstallationInsuranceMetadata">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Technique</label>
        <div class="form-check">
          <input
            type="radio"
            name="technicalInstallationsInsured"
            id="technicalInstallationsInsuredFalse"
            [value]="false"
            formControlName="technicalInstallationsInsured"
          />
          <label
            class="form-check-label"
            for="technicalInstallationsInsuredFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="technicalInstallationsInsured"
            id="technicalInstallationsInsuredTrue"
            [value]="true"
            formControlName="technicalInstallationsInsured"
          />
          <label
            class="form-check-label"
            for="technicalInstallationsInsuredTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <ng-container *ngIf="technicalInstallationsInsuredValue">
      <div class="row row-cols-md-2 row-cols-sm-1 my-3">
        <div class="col">
          <label i18n>Couverture complémentaire</label>
          <div class="form-check">
            <input
              type="radio"
              id="complementaryCoverageTechnicalFalse"
              [value]="false"
              formControlName="complementaryCoverage"
            />
            <label
              class="form-check-label"
              for="complementaryCoverageTechnicalFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              id="complementaryCoverageTechnicalTrue"
              [value]="true"
              formControlName="complementaryCoverage"
            />
            <label
              class="form-check-label"
              for="complementaryCoverageTechnicalTrue"
              >Oui</label
            >
          </div>
        </div>
      </div>

      <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
        Couverture Objets Informatiques
      </div>
      <ng-container formGroupName="computerObjectsCoverage">
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <div class="form-check">
              <input
                type="radio"
                id="computerObjectsCoveredFalse"
                [value]="false"
                formControlName="covered"
              />
              <label class="form-check-label" for="computerObjectsCoveredFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="computerObjectsCoveredTrue"
                [value]="true"
                formControlName="covered"
              />
              <label class="form-check-label" for="computerObjectsCoveredTrue"
                >Oui</label
              >
            </div>
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="computerObjectsCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Somme d'assurance (CHF)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise (CHF)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
        <div class="row my-3" *ngIf="computerObjectsCoverageCoveredValue">
          <div class="col">
            <label i18n>Inventaire</label>
            <textarea
              class="form-control"
              formControlName="inventory"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="computerObjectsCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Couverture coût de remplacement</label>
            <div class="form-check">
              <input
                type="radio"
                id="replacementCostComputerObjectsFalse"
                [value]="false"
                formControlName="replacementCostCoverage"
              />
              <label
                class="form-check-label"
                for="replacementCostComputerObjectsFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="replacementCostComputerObjectsTrue"
                [value]="true"
                formControlName="replacementCostCoverage"
              />
              <label
                class="form-check-label"
                for="replacementCostComputerObjectsTrue"
                >Oui</label
              >
            </div>
          </div>
          <div class="col">
            <label i18n
              >Dommages dus aux perturbations de fonctionnement
              intérieures</label
            >
            <div class="form-check">
              <input
                type="radio"
                id="internalOperatingDamageComputerObjectsFalse"
                [value]="false"
                formControlName="internalOperatingDamageCoverage"
              />
              <label
                class="form-check-label"
                for="internalOperatingDamageComputerObjectsFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="internalOperatingDamageComputerObjectsTrue"
                [value]="true"
                formControlName="internalOperatingDamageCoverage"
              />
              <label
                class="form-check-label"
                for="internalOperatingDamageComputerObjectsTrue"
                >Oui</label
              >
            </div>
          </div>
        </div>
      </ng-container>

      <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
        Couverture Installation Technique
      </div>
      <ng-container formGroupName="technicalInstallationCoverage">
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <div class="form-check">
              <input
                type="radio"
                id="technicalInstallationCoveredFalse"
                [value]="false"
                formControlName="covered"
              />
              <label
                class="form-check-label"
                for="technicalInstallationCoveredFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="technicalInstallationCoveredTrue"
                [value]="true"
                formControlName="covered"
              />
              <label
                class="form-check-label"
                for="technicalInstallationCoveredTrue"
                >Oui</label
              >
            </div>
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="technicalInstallationCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Somme d'assurance</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
        <div class="row my-3" *ngIf="technicalInstallationCoverageCoveredValue">
          <div class="col">
            <label i18n>Inventaire des ITG 1</label>
            <textarea
              class="form-control"
              formControlName="inventory"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="technicalInstallationCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Couverture en valeur à neuf</label>
            <div class="form-check">
              <input
                type="radio"
                id="replacementCostTechnicalInstallationFalse"
                [value]="false"
                formControlName="replacementCostCoverage"
              />
              <label
                class="form-check-label"
                for="replacementCostTechnicalInstallationFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="replacementCostTechnicalInstallationTrue"
                [value]="true"
                formControlName="replacementCostCoverage"
              />
              <label
                class="form-check-label"
                for="replacementCostTechnicalInstallationTrue"
                >Oui</label
              >
            </div>
          </div>
          <div class="col">
            <label i18n>Couverture des dommages d'exploitation internes</label>
            <div class="form-check">
              <input
                type="radio"
                id="internalOperatingDamageTechnicalInstallationFalse"
                [value]="false"
                formControlName="internalOperatingDamageCoverage"
              />
              <label
                class="form-check-label"
                for="internalOperatingDamageTechnicalInstallationFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="internalOperatingDamageTechnicalInstallationTrue"
                [value]="true"
                formControlName="internalOperatingDamageCoverage"
              />
              <label
                class="form-check-label"
                for="internalOperatingDamageTechnicalInstallationTrue"
                >Oui</label
              >
            </div>
          </div>
        </div>
      </ng-container>

      <label i18n
        >Supports de données et frais de reconstitution d'informations</label
      >
      <app-basic-coverage-form
        [formGroup]="getTechnicalBasicCoverageGroup('dataCarriersCoverage')"
        name="dataCarriersTechnical"
      />

      <label i18n>Objets informatiques en circulation en Suisse/FL</label>
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup('computerObjectsInSwitzerlandCoverage')
        "
        name="computerObjectsSwitzerland"
      />

      <label i18n>Objets informatiques dans le monde entier</label>
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup('computerObjectsInternationalCoverage')
        "
        name="computerObjectsInternational"
      />

      <label i18n>Câblage (si non compris dans l'assurance de base)</label>
      <app-basic-coverage-form
        [formGroup]="getTechnicalBasicCoverageGroup('wiringCoverage')"
        name="wiring"
      />

      <label i18n
        >Prestations supplémentaires de construction, frais de
        déblaiement</label
      >
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup(
            'additionalConstructionServicesCoverage'
          )
        "
        name="additionalConstructionServicesTechnical"
      />

      <label i18n>Frais supplémentaires pour objets informatiques</label>
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup(
            'computerObjectsAdditionalFeesCoverage'
          )
        "
        name="computerObjectsAdditionalFees"
      />

      <div class="row row-cols-md-2 row-cols-sm-1 my-3">
        <div class="col">
          <label i18n>Couverture cyber</label>
          <div class="form-check">
            <input
              type="radio"
              name="cyberCoverage"
              id="cyberCoverageFalse"
              [value]="false"
              formControlName="cyberCoverage"
            />
            <label class="form-check-label" for="cyberCoverageFalse">Non</label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="cyberCoverage"
              id="cyberCoverageTrue"
              [value]="true"
              formControlName="cyberCoverage"
            />
            <label class="form-check-label" for="cyberCoverageTrue">Oui</label>
          </div>
        </div>
      </div>

      <label i18n>Dommages dus aux troubles intérieurs</label>
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup('internalDisturbancesDamageCoverage')
        "
        name="internalDisturbancesTechnical"
      />

      <label i18n>Inaccessibilité en cas d'utilisation souterraine</label>
      <app-basic-coverage-form
        [formGroup]="
          getTechnicalBasicCoverageGroup('undergroundInaccessibilityCoverage')
        "
        name="undergroundInaccessibilityTechnical"
      />

      <label i18n
        >Exclusions des dommages dus à l'incendie, aux événements
        naturels</label
      >
      <div class="row row-cols-1 my-3">
        <div class="col">
          <div class="form-check">
            <input
              type="radio"
              id="technicalInstallationFireNaturalDisasterCoverageFalse"
              [value]="false"
              formControlName="fireNaturalDisasterCoverageExcluded"
            />
            <label
              class="form-check-label"
              for="technicalInstallationFireNaturalDisasterCoverageFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              id="technicalInstallationFireNaturalDisasterCoverageTrue"
              [value]="true"
              formControlName="fireNaturalDisasterCoverageExcluded"
            />
            <label
              class="form-check-label"
              for="technicalInstallationFireNaturalDisasterCoverageTrue"
              >Oui</label
            >
          </div>
        </div>
      </div>

      <label i18n>Dommages dus au vol pour les ITG</label>
      <app-basic-coverage-form
        [formGroup]="getTechnicalBasicCoverageGroup('theftCoverage')"
        name="theftTechnical"
      />

      <div class="form-subtitle flex-basis-100 mb-8 text-16" i18n>
        Perte d'exploitation
      </div>
      <ng-container formGroupName="lossCoverage">
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <div class="form-check">
              <input
                type="radio"
                id="technicalLossCoveredFalse"
                [value]="false"
                formControlName="covered"
              />
              <label class="form-check-label" for="technicalLossCoveredFalse"
                >Non</label
              >
            </div>
            <div class="form-check">
              <input
                type="radio"
                id="technicalLossCoveredTrue"
                [value]="true"
                formControlName="covered"
              />
              <label class="form-check-label" for="technicalLossCoveredTrue"
                >Oui</label
              >
            </div>
          </div>
          <div class="col" *ngIf="technicalLossCoverageCoveredValue">
            <label i18n>Délai de carence</label>
            <mat-form-field class="lty-input">
              <mat-select formControlName="waitingDelay">
                <mat-option [value]="null" i18n>Sélectionner</mat-option>
                <mat-option
                  *ngFor="let delay of waitingDaysValues"
                  [value]="delay"
                >
                  {{ getBusinessWaitingDaysLabel(delay) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row my-3" *ngIf="technicalLossCoverageCoveredValue">
          <div class="col">
            <label i18n>Couverture en</label>
            <input
              type="text"
              class="form-control"
              formControlName="coverageIn"
            />
          </div>
        </div>
        <div
          class="row row-cols-md-2 row-cols-sm-1 my-3"
          *ngIf="technicalLossCoverageCoveredValue"
        >
          <div class="col">
            <label i18n>Somme d'assurance</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="insuredSum"
            />
          </div>
          <div class="col">
            <label i18n>Franchise</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="deductible"
            />
          </div>
        </div>
      </ng-container>

      <div class="row row-cols-md-2 row-cols-sm-1 my-3">
        <div class="col">
          <label i18n>Exclusions des dommages dus au vol</label>
          <div class="form-check">
            <input
              type="radio"
              name="theftDamagesExcluded"
              id="theftDamagesExcludedFalse"
              [value]="false"
              formControlName="theftDamagesExcluded"
            />
            <label class="form-check-label" for="theftDamagesExcludedFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="theftDamagesExcluded"
              id="theftDamagesExcludedTrue"
              [value]="true"
              formControlName="theftDamagesExcluded"
            />
            <label class="form-check-label" for="theftDamagesExcludedTrue"
              >Oui</label
            >
          </div>
        </div>
        <div class="col">
          <label i18n>Exclusions des dommages en dégats d'eau</label>
          <div class="form-check">
            <input
              type="radio"
              name="waterDamagesExcluded"
              id="waterDamagesExcludedFalse"
              [value]="false"
              formControlName="waterDamagesExcluded"
            />
            <label class="form-check-label" for="waterDamagesExcludedFalse"
              >Non</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="waterDamagesExcluded"
              id="waterDamagesExcludedTrue"
              [value]="true"
              formControlName="waterDamagesExcluded"
            />
            <label class="form-check-label" for="waterDamagesExcludedTrue"
              >Oui</label
            >
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>
